module.exports = __webpack_public_path__ + "static/monthly-8c17cdcdb39478e4c5a1face9c8f483f.jpg";